import { CellAlign, CellType, HeadCell } from '@dfl/mui-admin-layout';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { IReportStockActivity } from '../interfaces/IReportStockActivity';
import { TranslateLabel } from 'modules/common/components/TranslateLabel';
import { ICoverageListItem } from '../interfaces/IReportInventoryCoverage';
import { CoverageStatusCell } from '../components/CoverageStatusCell';
import { NumberValue } from '@dfl/mui-react-common';

export const warehouseColumn: HeadCell<any> = {
  field: 'productInfo.warehouseName',
  headerName: 'common:provider.WAREHOUSE',
  renderCell: (value: string, data?: any) => {
    return (
      <AvatarNameCell
        link={`/inventory/warehouse/${data?.warehouse as string}/general`}
        hideImage
        name={value}
      />
    )
  },
};

export const productColumn: HeadCell<any> = {
  field: 'productInfo.name',
  headerName: 'incidence:actions.fields.product',
  disablePadding: false,
  renderCell: (value: string, data?: any) => (
    <AvatarNameCell
      hideImage
      secondary={data?.productInfo?.code}
      link={`/inventory/products/${data?.product as string}/general`}
      name={value || '-'}
    />
  ),
};

export const avgDailyUnitsColumn: HeadCell<IReportStockActivity> = {
  field: 'avgDailyUnits',
  headerName: 'product:section.inventory.avgDailyUnits',
  align: CellAlign.CENTER,
  renderCell: (value: number) => <NumberValue value={value || 0} />,
};

export const stockColumn = {
  field: 'stockEod',
  align: CellAlign.CENTER,
  translate: true,
  headerName: 'product:section.inventory.stock',
  type: CellType.NUMBER
}

export const availableColumn = {
  field: 'availableEod',
  align: CellAlign.CENTER,
  translate: true,
  headerName: 'product:section.inventory.available',
  type: CellType.NUMBER
}

export const coverageStatusColumn: HeadCell<ICoverageListItem> = {
  field: 'status',
  align: CellAlign.CENTER,
  translate: true,
  sortable: false,
  headerName: 'common:status',
  renderCell: (value: number, data: ICoverageListItem) => <CoverageStatusCell data={data} />,
}

export const coverageDaysColumn = {
  field: 'coverageDays',
  align: CellAlign.CENTER,
  translate: true,
  headerName: 'product:fields.coverage',
  renderCell: (value: number, data: any) => {
    const noSales = data?.coverageDays == null || (data?.avgDailyUnits ?? 0) === 0;
    return (
      <>{noSales ? <TranslateLabel label='inventoryCoverage.list.noSales' locale='report' /> : data?.coverageDays?.toFixed(1)}</>
    )
  },
}

export const coverageColumns: HeadCell[] = [
  productColumn,
  warehouseColumn,
  stockColumn,
  availableColumn,
  avgDailyUnitsColumn,
  coverageStatusColumn,
  coverageDaysColumn,
];
